import { Axios } from 'src/lib';

import { FronteggContext } from '@frontegg/rest-api';
import {
  quotaLoadingSlice,
  quotaSlice,
  timeQuotaSlice,
  timeQuotaLoadingSlice,
} from '../slices/quota.slice';

export const getQuotaAction = () => {
  return async (dispatch) => {
    dispatch(quotaLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await Axios.get(`/v2/quota`, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(quotaSlice(response));
      }
    } catch (error) {
      console.error('Error fetching quota:', error);
    } finally {
      dispatch(quotaLoadingSlice(false));
    }
  };
};

export const getTimeQuotaAction = () => {
  return async (dispatch) => {
    dispatch(timeQuotaLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await Axios.get(`/v2/quota/time`, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(timeQuotaSlice(response));
      }
    } catch (error) {
      console.error('Error fetching time quota:', error);
    } finally {
      dispatch(timeQuotaLoadingSlice(false));
    }
  };
};
